import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles({
  resetMarginTop: {
    // reset marginTop of .section .field
    marginTop: [0, '!important']
  },
  selectedOptionsWrapper: {
    display: ['block', '!important'],
    paddingBottom: [0, '!important']
  }
})

export default useStyles
